import { Tab } from '@/libs/tab'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useTabStore = defineStore('tab', () => {
  const tabs = ref<Tab[]>([])
  const activeTab = ref<Tab>()
  function clearActiveTab() {
    if (activeTab.value) {
      activeTab.value.isActive = false
    }
  }
  function setActiveTab(tab: Tab) {
    clearActiveTab()
    activeTab.value = tab
    activeTab.value.isActive = true
  }
  function setActiveTabByIndex(index: number) {
    if (index > -1 && index < tabs.value.length) {
      setActiveTab(tabs.value[index])
    }
  }
  function findTabById(id: string) {
    return tabs.value.find(t => t.id === id)
  }
  function addTab(tab: Tab, makeActive = false) {
    const existingTab = tabs.value.find(t => t.id === tab.id)
    let index = -1
    if (!existingTab) {
      index = tabs.value.push(tab) - 1
    } else {
      index = tabs.value.indexOf(existingTab)
    }
    if (makeActive) {
      setActiveTab(tab)
    }
    return index
  }
  function removeTab(thisTab: Tab) {
    const tabIndex = tabs.value.indexOf(thisTab)
    if (tabIndex > -1) {
      tabs.value.splice(tabIndex, 1)
    }
  }
  function removeTabByIndex(tabIndex: number) {
    if (tabIndex > -1) {
      tabs.value.splice(tabIndex, 1)
    }
  }
  return {
    tabs,
    addTab,
    activeTab,
    removeTab,
    findTabById,
    removeTabByIndex,
    setActiveTab,
    setActiveTabByIndex
  }
})
